import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ShopProductLine } from '../../models/shopProductLine.interface';
import { IDigitalProductTileDelegate } from '../digital-product-tile/digital-product-tile.component';

export interface IDigitalProductListDelegate {
    onListItemClicked(productLine: ShopProductLine): void;
}

@Component({
    selector: 'modeso-digital-product-list',
    templateUrl: './digital-product-list.component.html',
    styleUrls: ['./digital-product-list.component.scss'],
})
export class DigitalProductListComponent implements IDigitalProductTileDelegate, OnInit {
    hasEvenProducts: boolean = false;
    @Input() products: ShopProductLine[] = [];
    @Input() delegate?: IDigitalProductListDelegate;
    @Output() imagesLoadedSources: EventEmitter<string> = new EventEmitter();

    ngOnInit(): void {
        this.hasEvenProducts = this.isEvenProductCount();
    }

    onTileClick(product: ShopProductLine): void {
        this.delegate.onListItemClicked(product);
    }

    handleImageLoaded(source: string): void {
        this.imagesLoadedSources.emit(source);
    }

    private isEvenProductCount(): boolean {
        return this.products.length % 2 === 0;
    }
}
